const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export default defineNuxtPlugin(async () => {
  const { data, refresh } = useAuth();
  const refreshTokenCookie = useCookie('auth.refreshToken');

  if (!data.value && refreshTokenCookie.value) {
    // On native, the network may not be ready immediately after app launch.
    // Retry up to 3 times with increasing delays before giving up.
    const { Capacitor } = await import('@capacitor/core');
    const attempts = Capacitor.isNativePlatform() ? 3 : 1;
    let lastError: unknown;

    for (let i = 0; i < attempts; i++) {
      if (i > 0) await wait(i * 1500);
      try {
        await refresh();
        return;
      } catch (e) {
        lastError = e;
      }
    }

    console.error('auth-refresh failed after retries', lastError);

    if (Capacitor.isNativePlatform()) {
      try {
        const { FirebaseMessaging } = await import('@capacitor-firebase/messaging');
        await FirebaseMessaging.deleteToken();
        localStorage.removeItem('nativePushToken');
      } catch {
        // ignore
      }
    }
  }
});
